import { useQuery } from '@tanstack/react-query';
import { container } from '@infrastructure/di/container';
import { QUERY_KEYS } from '@shared/constants';

export const useVariableHygiene = (workspaceId: string | undefined, enabled: boolean) => {
  return useQuery({
    queryKey: QUERY_KEYS.variableHygiene(workspaceId ?? ''),
    queryFn: () => container.variableHygiene.analyze(workspaceId as string),
    enabled: Boolean(workspaceId) && enabled,
  });
};
